import { render, staticRenderFns } from "./rendicion.vue?vue&type=template&id=2dfcdb77&scoped=true&"
import script from "./rendicion.vue?vue&type=script&lang=js&"
export * from "./rendicion.vue?vue&type=script&lang=js&"
import style0 from "./rendicion.vue?vue&type=style&index=0&id=2dfcdb77&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfcdb77",
  null
  
)

export default component.exports